import * as React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import * as moment from 'moment';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import Select from 'react-select';
import {
    COMMON_FORM_STAGE,
    CREATE_FORM_STAGE,
    createForms,
    FLOW_STATUS,
    FORM_TYPE,
    formsCanUpdatePolicy,
    formsWithFormType,
    formTypeOptions,
    identityOptions,
    POLICY_TYPE,
    redirectForms,
    stagesCanPrint,
    stagesEditable,
    stagesWithoutMidasNo,
    stagesWithoutStatus,
    STATUS,
    UPDATE_FORM_STAGE,
    updateForms,
    updateStages,
    URL,
    VERIFY_FORM_STAGE
} from '../../Config/appConfig';
import {
    CnSummary,
    CoverNote,
    CreateCoverNote,
    CreatePolicy,
    Hmac,
    Identity,
    InsurePolicy,
    InsurerId,
    Option,
    UpdateDocument,
    VoidDocument,
    ReduxUpdatedState
} from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import coverNoteDispatch from '../../ReduxRequests/Dispatch/coverNoteDispatch';
import policyDispatch from '../../ReduxRequests/Dispatch/policyDispatch';
import qrCodeDispatch from '../../ReduxRequests/Dispatch/qrCodeDispatch';
import authState from '../../ReduxRequests/State/authState';
import coverNoteState from '../../ReduxRequests/State/coverNoteState';
import policyState from '../../ReduxRequests/State/policyState';
import qrCodeState from '../../ReduxRequests/State/qrCodeState';
import {assertAllTrue, assertTrue, clearErrors, throwErrorClient} from '../../Util/errorUtil';
import util from '../../Util/util';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import Calendar from '../Custom/Calendar';
import CloseButton from '../Custom/CloseButton';
import CommonFormActionButtons from './CommonFormActionButtons';
import HistoryDropDown from '../Custom/HistoryDropDown';
import IdentityInput from '../Custom/IdentityInput';
import QRCodeDownloadable from '../Custom/QRCodeDownloadable';
import Modal from '../Modal/Modal';
import { reactSelectStyles } from '../constants';
import CustomDatePicker from '../Custom/CustomDatePicker';

const pageSpinner = require('../../resource/img/page-loading.gif');

const mapDispatchToProps = (dispatch) => {
    return {
        ...coverNoteDispatch(dispatch),
        ...policyDispatch(dispatch),
        ...qrCodeDispatch(dispatch),
        ...authDispatch(dispatch)
    }
};

const mapStateToProps = (state) => {
    return {
        ...coverNoteState(state),
        ...policyState(state),
        ...qrCodeState(state),
        ...authState(state)
    }
};

interface CommonFormProps {
    insurerId: () => InsurerId;
    isInsurer: () => boolean,
    refNo: string,
    formType: string,
    changeRefNo: (refNo: string) => void,
    changeFormType: (formType: string) => void,
    fetchCoverNote: (ref: string, insurerId: InsurerId) => void,
    coverNote: CoverNote,
    fetchQRCode: (ref: string, insurerId: InsurerId) => void,
    qrCode: ReduxUpdatedState,
    subAgentApplyCN: (data: CreateCoverNote) => void,
    insurerApplyCN: (data: CreateCoverNote) => void,
    cnSummary: CnSummary,
    insurerApplyPY: (data: CreatePolicy) => void,
    pySummary: CnSummary,
    insurerConfirmCN: (ref: string, data: Identity) => void,
    confirmCnSummary: CnSummary,
    insurerInsurePY: (ref: string, data: InsurePolicy) => void,
    updateCoverNote: (ref: string, data: UpdateDocument) => void,
    updatePolicy: (ref: string, data: UpdateDocument) => void,
    voidCoverNote: (ref: string, data: VoidDocument) => void,
    voidCnSummary: CnSummary,
    validateIdentityNo: (hmac: Hmac) => void,
    validationState: () => boolean,
    fetchCoverNoteHistory: (ref: string, insurerId: InsurerId) => void,
    coverNoteHistory: CoverNote[]
}

interface CommonFormState {
    stage: string,
    flowStatus: string,
    midasNo: string,
    issueNo: string,
    identity: Option,
    identityNo: string,
    checksum: string,
    chassisNo: string,
    license: string,
    insurerOptions: Option[],
    subagent: string,
    coverPeriod: number,
    startDate: moment.Moment,
    endDate: moment.Moment,
    voidDate: moment.Moment,
    policyType: string,
    status: string,
    qrCode: string,
    hmac: string,
    validIdentityNo: boolean,
    validChassisNo: boolean,
    printFields: {
        midasNo: boolean,
        issueNo: boolean,
        identity: boolean,
        chassisNo: boolean,
        license: boolean,
        insurer: boolean,
        subagent: boolean,
        coverPeriod: boolean,
        policyType: boolean,
        status: boolean
    },
    invalidFields: {
        issueNo: boolean,
        identity: boolean,
        chassisNo: boolean
    },
    origIssueNo: string,
    origLicense: string,
    origStartDate: moment.Moment,
    origEndDate: moment.Moment,
    history: CoverNote[],
    btnLoading: boolean,
    contentFetched: boolean,
    qrCodeFetched: boolean,
    displayModal: boolean
}

class CommonForm extends React.Component <RouteComponentProps & CommonFormProps, CommonFormState> {
    public componentMountedAt : moment.Moment = moment();
    public convertToPolicy: boolean = false;
    public checkIdentity: boolean = false;

    public constructor(props: CommonFormProps) {
        super(props);
        this.state = {
            stage: '',
            flowStatus: '',
            midasNo: '',
            issueNo: '',
            identity: identityOptions[0],
            identityNo: '',
            checksum: '',
            chassisNo: '',
            license: '',
            insurerOptions: [],
            subagent: '',
            coverPeriod: 30,
            startDate: moment().startOf('day'),
            endDate: this.getEndDate(moment().add(29, 'days')),
            voidDate: moment(),
            policyType: '',
            status: '',
            qrCode: '',
            hmac: '',
            validIdentityNo: true,
            validChassisNo: true,
            printFields: {
                midasNo: true,
                issueNo: true,
                identity: true,
                chassisNo: true,
                license: false,
                insurer: true,
                subagent: true,
                coverPeriod: true,
                policyType: true,
                status: true
            },
            invalidFields: {
                issueNo: false,
                identity: false,
                chassisNo: false
            },
            origIssueNo: '',
            origLicense: '',
            origStartDate: null,
            origEndDate: null,
            history: [],
            btnLoading: false,
            contentFetched: false,
            qrCodeFetched: false,
            displayModal: false
        };
        this.blurCoverPeriod = this.blurCoverPeriod.bind(this);
        this.changeIssueNo = this.changeIssueNo.bind(this);
        this.changeIdentity = this.changeIdentity.bind(this);
        this.changeIdentityNo = this.changeIdentityNo.bind(this);
        this.changeChecksum = this.changeChecksum.bind(this);
        this.changeChassisNo = this.changeChassisNo.bind(this);
        this.changeLicense = this.changeLicense.bind(this);
        this.changeCoverPeriod = this.changeCoverPeriod.bind(this);
        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.changeVoidDate = this.changeVoidDate.bind(this);
        this.changePrintField = this.changePrintField.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.clickConfirm = this.clickConfirm.bind(this);
        this.clickUpdate = this.clickUpdate.bind(this);
        this.clickProceed = this.clickProceed.bind(this);
        this.clickApprove = this.clickApprove.bind(this);
        this.clickApproveAndIssue = this.clickApproveAndIssue.bind(this);
        this.clickVoid = this.clickVoid.bind(this);
        this.clickPrint = this.clickPrint.bind(this);
        this.clickClose = this.clickClose.bind(this);
        this.handleModal = this.handleModal.bind(this);
        this.redirect = this.redirect.bind(this);
        this.onError = this.onError.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('mousedown', this.blurCoverPeriod);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.blurCoverPeriod);
    }

    public componentDidMount() {
        if (this.props.location.state) {
            this.props.changeFormType(this.props.location.state.formType);
        }
        switch (this.props.formType) {
            case FORM_TYPE.IN_VIEW_COVER_NOTE:
            case FORM_TYPE.SA_VIEW_POLICY:
            case FORM_TYPE.UPDATE_COVER_NOTE:
            case FORM_TYPE.UPDATE_POLICY:
                this.props.fetchCoverNote(this.props.refNo, this.getInsurerId());
                this.props.fetchQRCode(this.props.refNo, this.getInsurerId());
                this.props.fetchCoverNoteHistory(this.props.refNo, this.getInsurerId());
                break;
            case FORM_TYPE.SA_CREATE_COVER_NOTE:
                this.setSubagent();
                break;
            case FORM_TYPE.IN_CREATE_COVER_NOTE:
            case FORM_TYPE.IN_CREATE_POLICY:
                this.changeStage(CREATE_FORM_STAGE.CREATE);
                break;
            default:
                break;
        }
    }

    public componentWillReceiveProps(nextProps: CommonFormProps) {
        if (nextProps.coverNote !== this.props.coverNote) {
            this.setCoverNote(nextProps.coverNote);
        }
        if (nextProps.cnSummary !== this.props.cnSummary) {
            if (nextProps.cnSummary.status === 'RECEIVED') this.setSummary(nextProps.cnSummary, formTypeOptions[0].label);
            else throwErrorClient(0);
        }
        if (nextProps.pySummary !== this.props.pySummary) {
            if (nextProps.pySummary.status === 'RECEIVED') this.setSummary(nextProps.pySummary, formTypeOptions[1].label);
            else throwErrorClient(0);
        }
        if (nextProps.confirmCnSummary !== this.props.confirmCnSummary) {
            if (nextProps.confirmCnSummary.status === 'RECEIVED') this.setConfirmCnSummaryStatus(nextProps.confirmCnSummary.id);
            else throwErrorClient(0);
        }
        if (nextProps.qrCode && nextProps.qrCode.updatedAt.isAfter(this.componentMountedAt) && nextProps.qrCode.value !== this.state.qrCode) {
            this.setQRCode(nextProps.qrCode.value);
        }
        if (nextProps.voidCnSummary !== this.props.voidCnSummary) {
            if (nextProps.voidCnSummary.status === 'RECEIVED') this.leave();
            else throwErrorClient(0);
        }
        if (nextProps.formType !== this.props.formType && nextProps.formType !== FORM_TYPE.UPDATE_COVER_NOTE) {
             this.setCoverPeriod(nextProps.formType);
        }
        if (this.checkIdentity && nextProps.validationState()) {
            this.setValidationStatus(nextProps.validationState());
        }
        if (nextProps.coverNoteHistory !== this.props.coverNoteHistory) {
            this.setCoverNoteHistory(nextProps.coverNoteHistory);
        }
    }

    public setCoverNote(coverNote: CoverNote) {
        const data = coverNote.state.data;
        this.setState({
            stage: (this.props.location.state && this.props.location.state.stage) ? this.props.location.state.stage : this.getCoverNoteStage(data.status),
            flowStatus: data.status,
            midasNo: data.midasRef,
            issueNo: data.props.policyReference,
            identity: (this.props.location.state && this.props.location.state.identity) ? this.props.location.state.identity : identityOptions[0],
            identityNo: (this.props.location.state && this.props.location.state.identityNo) ? this.props.location.state.identityNo : '',
            checksum: (this.props.location.state && this.props.location.state.checksum) ? this.props.location.state.checksum : '',
            chassisNo: data.props.chassisNumber,
            license: data.props.licensePlateNumber,
            subagent: util.getSubagentName(data.props.subAgentCode, data.props.insurerCode, this.props.auth(), this.props.isInsurer()),
            coverPeriod: this.getCoverPeriod(util.getDate(data.props.policyStartDate), util.getDate(data.props.policyEndDate)),
            startDate: util.getDate(data.props.policyStartDate),
            endDate: util.getDate(data.props.policyEndDate),
            voidDate: util.getDate(data.props.policyStartDate),
            policyType: util.getPolicyType(data.props.policyType),
            status: util.getStatus(data.props.policyEndDate, data.status, false),
            hmac: data.props.hmac,
            origIssueNo: data.props.policyReference,
            origLicense: data.props.licensePlateNumber,
            origStartDate: util.getDate(data.props.policyStartDate),
            origEndDate: util.getDate(data.props.policyEndDate),
            contentFetched: true
        });
    }

    public setSubagent() {
        this.setState({
            stage: CREATE_FORM_STAGE.CREATE,
            subagent: this.props.auth().user.company
        });
    }

    public setSummary(data: CnSummary, type: string) {
        this.scrollToTop();
        this.props.fetchCoverNoteHistory(`${data.id}(0)`, this.getInsurerId());
        this.props.fetchQRCode(`${data.id}(0)`, this.getInsurerId());
        this.props.changeRefNo(`${data.id}(0)`);
        this.setState({
            stage: this.getSummaryStage(type),
            flowStatus: FLOW_STATUS.CONFIRMED,
            midasNo: data.ref,
            policyType: type,
            status: util.getFlowStatus(false, data.policyStatus, false)
        });
        this.setBtnLoading(false);
    }

    public setQRCode(data: string) {
        this.setState({
            qrCode: data,
            qrCodeFetched: true
        });
    }

    public setCoverPeriod(data: string) {
        const days = formsCanUpdatePolicy.indexOf(data) !== -1 ? 365 : 30;
        this.setState({
            coverPeriod: days,
            startDate: moment().startOf('day'),
            endDate: this.getEndDate(moment().add(days - 1, 'days'))
        });
    }

    public setValidationStatus(data: boolean) {
        this.scrollToTop();
        this.checkIdentity = false;
        if (data) {
            this.setState({
                stage: this.getStageAfterProceed(this.state.flowStatus),
                validIdentityNo: true
            });
            this.setBtnLoading(false);
        }
        else {
            this.setState({
                validIdentityNo: false
            });
            this.setBtnLoading(false);
        }
    }

    public setConfirmCnSummaryStatus(id: string) {
        this.setBtnLoading(false);
        if (this.convertToPolicy) {
            this.scrollToTop();
            this.setState({
                stage: VERIFY_FORM_STAGE.CONVERT_TO_POLICY,
                issueNo: ''
            });
            this.changeForm(FORM_TYPE.IN_CONVERT_TO_POLICY, id);
            this.props.fetchCoverNoteHistory(this.props.refNo, this.getInsurerId());
        }
        else {
            this.props.history.push(util.getDest(this.props.history.location.pathname.split('/')[2]));
        }
    }

    public setCoverNoteHistory(data: CoverNote[]) {
        this.setState({
            history: data
        });
    }

    public setDisplayModal(display: boolean) {
        this.setState({
            displayModal: display
        });
    }

    public setBtnLoading(btnLoading: boolean) {
        this.setState({btnLoading});
    }

    public getEndDate(date: moment.Moment) {
        return date.set({hour: 23, minute: 59, second: 59, millisecond: 0})
    }

    public getStageAfterProceed(status: string) {
        if (updateForms.indexOf(this.props.formType) !== -1) return UPDATE_FORM_STAGE.UPDATE;
        else if (status && status === FLOW_STATUS.CONFIRMED) return VERIFY_FORM_STAGE.ISSUE_POLICY;
        else return VERIFY_FORM_STAGE.APPROVE_CN;
    }

    public changeForm(formType: string, id: string) {
        this.props.changeFormType(formType);
        this.props.changeRefNo(`${id}(0)`);
    }

    public getCoverNoteStage(status: string) {
        const stage = this.props.location.state && this.props.location.state.searchResult ? this.getStageAfterProceed(status) : COMMON_FORM_STAGE.PROCEED;
        if (this.props.isInsurer()) {
            return status === FLOW_STATUS.VOIDED ? COMMON_FORM_STAGE.PRINT : stage;
        }
        else {
            return status === FLOW_STATUS.CREATED ? stage : COMMON_FORM_STAGE.PRINT;
        }
    }

    public getSummaryStage(type: string) {
        switch (this.props.formType) {
            case FORM_TYPE.UPDATE_COVER_NOTE:
            case FORM_TYPE.UPDATE_POLICY:
                return UPDATE_FORM_STAGE.UPDATE_SUMMARY;
            default:
                return type === formTypeOptions[1].label ? CREATE_FORM_STAGE.CREATE_PY_SUMMARY : CREATE_FORM_STAGE.CREATE_CN_SUMMARY;
        }
    }

    public getIdentityNo() {
        return util.getIdentityNo(this.state.identity.value, this.state.identityNo, this.state.checksum);
    }

    public getIdentity() {
        return {...{docId: this.getIdentityNo(), docType: this.state.identity.value}, ...this.getInsurerId()};
    }

    public getInsurerId() {
        return this.props.insurerId();
    }

    public getCoverPeriod(start: moment.Moment, end: moment.Moment) {
        const startDate = start.clone();
        const endDate = end.clone();
        return util.getDuration(startDate, endDate);
    }

    public changeIssueNo(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const issueNo = event.target.value;
        this.setState({
            issueNo
        });
    }

    public changeIdentity(identity: Option) {
        this.setState({
            identity,
            identityNo: '',
            checksum: ''
        });
    }

    public changeIdentityNo(identityNo: string) {
        this.setState({
            identityNo
        });
    }

    public changeChecksum(checksum: string) {
        this.setState({
            checksum
        });
    }

    public changeChassisNo(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const chassisNo = event.target.value.toUpperCase();
        if (chassisNo.length <= 25) {
            this.setState({
                chassisNo
            });
        }
    }

    public changeLicense(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const license = event.target.value.toUpperCase();
        if (license.length <= 8 && license.match(/^([A-Z0-9\s]|)+$/i) && !license.match(/[IOQ]/)) {
            this.setState({
                license,
                printFields: Object.assign(this.state.printFields, {
                    license: license !== ''
                })
            });
        }
    }

    public blurCoverPeriod() {
        if (this.state.coverPeriod < 2) {
            this.setState({
                coverPeriod: 2
            })
        }
    }

    public changeCoverPeriod(event: any) {
        event.preventDefault();
        const data = event.target.value;
        if (data.match(/^([0-9]*)$/) && data < 10000) {
            this.setState({
                coverPeriod: data,
                endDate: this.getEndDate(moment(this.state.startDate).add(data && data > 1 ? data - 1 : 1, 'days'))
            });
        }
    }

    public changeStartDate(date: moment.Moment) {
        this.setState({
            startDate: date,
            endDate: this.getEndDate(moment(date).add(this.state.coverPeriod - 1, 'days'))
        });
    }

    public changeEndDate(date: moment.Moment) {
        this.setState({
            coverPeriod: this.getCoverPeriod(this.state.startDate, date),
            endDate: date
        });
    }

    public changeVoidDate(date: moment.Moment) {
        this.setState({
            voidDate: date
        });
    }

    public changePrintField(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const target = event.target;
        const printFields = {...this.state.printFields};
        printFields[target.name] = target.checked;
        this.setState({printFields});
    }

    public changeStage(stage: string) {
        this.setState({
            stage
        });
    }

    public checkRequiredInput() {
        const isNonBlankIssueNo = this.state.issueNo.length > 0;
        const isNonBlankIdentityNo = this.state.identityNo.length > 0;
        const isNonBlankChassisNo = this.state.chassisNo.length > 0;
        return {
            isNonBlankIssueNo,
            isNonBlankIdentityNo,
            isNonBlankChassisNo
        }
    }

    public checkOptionalInput() {
        const isNonBlankChecksum = this.state.checksum.length > 0;
        const isNonBlankLicense = this.state.license.length > 0;
        return {
            isNonBlankChecksum,
            isNonBlankLicense
        }
    }

    public clickSubmit(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.scrollToTop();
        clearErrors();
        const checkResult = this.checkRequiredInput();
        const nonBlank = assertAllTrue([
            {code: 153, hasResult: checkResult.isNonBlankIssueNo},
            {code: 154, hasResult: checkResult.isNonBlankIdentityNo},
            {code: 155, hasResult: checkResult.isNonBlankChassisNo}
        ]);
        this.setState({
            invalidFields: Object.assign(this.state.invalidFields, {
                issueNo: !checkResult.isNonBlankIssueNo,
                identity: !checkResult.isNonBlankIdentityNo,
                chassisNo: !checkResult.isNonBlankChassisNo
            })
        });
        if (!nonBlank) {
            return;
        }
        const isValidIdentityNo = util.isIdentityNoValid(this.state.identity.value, this.state.identityNo, this.state.checksum);
        const isValidChassisNumber = util.isValidChassisNumber(this.state.chassisNo);
        this.setState({
            invalidFields: Object.assign(this.state.invalidFields, {
                identity: !isValidIdentityNo,
                chassisNo: !isValidChassisNumber
            })
        });
        const valid = assertAllTrue([
            { code: 170, hasResult: isValidIdentityNo },
            { code: 171, hasResult: isValidChassisNumber }
        ]);
        if (!valid) {
            return;
        }
        this.setState({
            stage: (this.props.formType === FORM_TYPE.UPDATE_COVER_NOTE ? UPDATE_FORM_STAGE.CONFIRM_UPDATE : CREATE_FORM_STAGE.CONFIRM_CREATE)
        });
    }

    public clickConfirm(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setBtnLoading(true);
        this.props.history.replace({
            state: undefined
        });
        if (this.state.stage === UPDATE_FORM_STAGE.CONFIRM_VOID) {
            const data = {
                ...{
                    policyVoidDate: this.state.voidDate
                }, ...this.getIdentity()
            };
            this.props.voidCoverNote(this.props.refNo, data);
        }
        else {
            let data = {
                ...{
                    policyReference: this.state.issueNo,
                    licensePlateNumber: this.state.license,
                    policyStartDate: this.state.startDate.format(),
                    policyEndDate: this.state.endDate.format()
                }, ...this.getIdentity()
            };
            if (createForms.indexOf(this.props.formType) !== -1) {
                data = {
                    ...{
                        applicantEmail: this.props.auth().user.email,
                        chassisNumber: this.state.chassisNo,
                        policyType: this.props.formType === FORM_TYPE.IN_CREATE_POLICY ? POLICY_TYPE.POLICY : POLICY_TYPE.COVER_NOTE
                    }, ...data
                };
            }
            switch (this.props.formType) {
                case FORM_TYPE.IN_CREATE_POLICY:
                    this.props.insurerApplyPY(data);
                    break;
                case FORM_TYPE.IN_CONVERT_TO_POLICY:
                    this.props.insurerInsurePY(this.props.refNo, data);
                    break;
                case FORM_TYPE.UPDATE_COVER_NOTE:
                    this.props.updateCoverNote(this.props.refNo, data);
                    break;
                case FORM_TYPE.UPDATE_POLICY:
                    this.props.updatePolicy(this.props.refNo, data);
                    break;
                case FORM_TYPE.SA_CREATE_COVER_NOTE:
                    this.props.subAgentApplyCN(data);
                    break;
                case FORM_TYPE.IN_CREATE_COVER_NOTE:
                    this.props.insurerApplyCN(data);
                    break;
                default:
                    break;
            }
        }
    }

    public clickUpdate(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.scrollToTop();
        clearErrors();
        if (!assertTrue(153, this.state.issueNo.length > 0)) {
            return;
        }
        const isArchived = this.props.history.location.pathname.includes(URL.ARCHIVED);
        let path = '';
        if (isArchived) {
            path = this.props.formType === FORM_TYPE.UPDATE_POLICY ? URL.VIEW_ARCHIVED_POLICY.split('/:id')[0] : URL.VIEW_ARCHIVED_COVER_NOTE.split('/:id')[0];
        }
        else {
            path = this.props.formType === FORM_TYPE.UPDATE_POLICY ? URL.POLICY : URL.COVER_NOTE;
        }
        if (updateForms.indexOf(this.props.formType) !== -1) {
            this.props.history.push(`${path}/${this.props.refNo}`);
        }
        else {
            this.props.changeFormType(FORM_TYPE.UPDATE_COVER_NOTE);
        }
        this.setState({
            stage: this.state.stage === UPDATE_FORM_STAGE.UPDATE ? UPDATE_FORM_STAGE.CONFIRM_UPDATE : UPDATE_FORM_STAGE.UPDATE
        });
    }

    public clickProceed(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        clearErrors();
        const nonBlank = assertAllTrue([
            {code: 154, hasResult: this.state.identityNo.length > 0}
        ]);
        if (!nonBlank) {
            return;
        }
        const valid = assertAllTrue([
            {
                code: 170,
                hasResult: util.isIdentityNoValid(this.state.identity.value, this.state.identityNo, this.state.checksum)
            },
            {
                code: 171,
                hasResult: util.isValidChassisNumber(this.state.chassisNo)
            }
        ]);
        if (!valid) {
            return;
        }
        this.setBtnLoading(true);
        const data = {
            ...{
                docId: this.getIdentityNo(),
                docType: this.state.identity.value,
                hmac: this.state.hmac
            }, ...this.getInsurerId()
        };
        this.checkIdentity = true;
        this.props.validateIdentityNo(data);
    }

    public clickApprove(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setBtnLoading(true);
        this.props.insurerConfirmCN(this.props.refNo, this.getIdentity());
    }

    public clickApproveAndIssue(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setBtnLoading(true);
        this.convertToPolicy = true;
        this.props.insurerConfirmCN(this.props.refNo, this.getIdentity());
    }

    public clickVoid(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.scrollToTop();
        this.setState({
            issueNo: this.state.origIssueNo,
            license: this.state.origLicense,
            coverPeriod: this.getCoverPeriod(this.state.origStartDate, this.state.origEndDate),
            startDate: this.state.origStartDate,
            endDate: this.state.origEndDate,
            stage: UPDATE_FORM_STAGE.CONFIRM_VOID
        });
    }

    public clickPrint(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        window.print();
    }

    public clickClose(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        if (updateStages.indexOf(this.state.stage) !== -1) {
            this.setDisplayModal(true);
            return;    
        }
        else if (stagesCanPrint.indexOf(this.state.stage) === -1 && redirectForms.indexOf(this.props.formType) !== -1) {
            const checkResult = {...this.checkRequiredInput(), ...this.checkOptionalInput()};
            for (let item in checkResult) {
                if (checkResult[item]) {
                    this.setDisplayModal(true);
                    return;
                }
            }
        }
        this.leave();
    }

    public handleModal(event: React.MouseEvent<HTMLElement>, leave: boolean) {
        event.preventDefault();
        this.setDisplayModal(false);
        if (leave) this.leave();
    }

    public leave() {
        if (this.props.location.state && this.props.location.state.searchResult && this.state.stage !== UPDATE_FORM_STAGE.CONFIRM_VOID) {
            this.props.history.replace({
                pathname: URL.SEARCH,
                state: {
                    searchResult: this.props.location.state.searchResult,
                    identity: this.props.location.state.identity,
                    identityNo: this.props.location.state.identityNo,
                    checksum: this.props.location.state.checksum
                }
            });
        }
        else if (this.props.location.state && this.props.location.state.fromDashboard) this.props.history.goBack();
        else {
            this.props.history.push(moment(this.state.endDate).isSameOrBefore(moment()) ? URL.ARCHIVED : 
                (this.state.policyType === formTypeOptions[1].label ? URL.POLICY : util.getDest(this.props.history.location.pathname.split('/')[2])));
        }
    }

    public redirect(formType: string, stage: string) {
        const data = {
            stage,
            identity: this.state.identity,
            identityNo: this.state.identityNo,
            checksum: this.state.checksum
        };
        if (formType === FORM_TYPE.IN_CONVERT_TO_POLICY) {
            this.scrollToTop();
            this.props.changeFormType(formType);
            const newData = {
                ...{
                    issueNo: formType === FORM_TYPE.IN_CONVERT_TO_POLICY ? '' : this.state.issueNo,
                    startDate: this.state.startDate,
                    endDate: this.state.endDate
                }, ...data
            };
            this.setState(newData);
        }
        else {
            const newData = {...{formType}, ...data};
            this.props.history.push({
                pathname: `${formType === FORM_TYPE.UPDATE_POLICY ? URL.POLICY : URL.COVER_NOTE}/${this.props.refNo}`,
                state: newData
            });
        }
    }

    public onError() {
        this.setBtnLoading(false);
    }

    public scrollToTop() {
        window.scrollTo(0, 0);
    }

    public getModalContent() {
        return (<div className="cmText modalText modalTextSm">Are you sure you want to leave this page?</div>);
    }

    public render() {
        const titles = util.getTitle(this.props.formType, this.state.stage);
        return (
            <div className="cmHorCenter cmFormContainer commonForm">
                {(this.state.contentFetched || createForms.indexOf(this.props.formType) !== -1) ?
                    <div>
                        <div>
                            <div className="cmFormTitleHeader">
                                <div className="cmFormTitle">{titles.title}</div>
                                <CloseButton
                                    type={this.state.status === STATUS.EXPIRED ? STATUS.EXPIRED : this.state.policyType}
                                    clickClose={this.clickClose}/>
                            </div>
                            {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                            <div className="cmInfo">Choose which field(s) to print</div>}
                        </div>
                        <div>
                            <div>
                                {(formsWithFormType.indexOf(this.props.formType) !== -1) &&
                                (this.state.stage === CREATE_FORM_STAGE.CREATE) &&
                                <div className="cmInput cmFormInput">
                                    <label className="cmInputLabel">Form Type</label>
                                    <Select
                                        styles={reactSelectStyles}
                                        className="react-select__container"
                                        classNamePrefix="react-select"
                                        options={formTypeOptions}
                                        value={this.props.formType === FORM_TYPE.IN_CREATE_COVER_NOTE ? formTypeOptions[0] : formTypeOptions[1]}
                                        clearable={false}
                                        onChange={(formType) => formType && this.props.changeFormType(formType.value)}
                                        isDisabled={this.state.stage !== CREATE_FORM_STAGE.CREATE}/>
                                </div>}
                                {(stagesWithoutMidasNo.indexOf(this.state.stage) === -1 || this.props.formType === FORM_TYPE.IN_CONVERT_TO_POLICY) &&
                                <div
                                    className={`cmInput cmFormInput cmDisabledInput${this.state.printFields.midasNo ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="midasNo"
                                        checked={this.state.printFields.midasNo}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Midas Number"
                                        value={this.state.midasNo}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </div>}
                                <div
                                    className={`cmInput cmFormInput${stagesEditable.indexOf(this.state.stage) === -1 ? ' cmDisabledInput' : ''}${this.state.printFields.issueNo ? '' : ' noPrint'}${this.state.invalidFields.issueNo ? ' invalidField' : ''}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="issueNo"
                                        checked={this.state.printFields.issueNo}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label={titles.rowTitle1}
                                        value={this.state.issueNo}
                                        onChange={this.changeIssueNo}
                                        disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                        InputProps={{disableUnderline: true, inputProps: {maxLength: 20}}}/>
                                </div>
                                <div
                                    className={`cmInput commonFormIdentity${!(this.state.stage === CREATE_FORM_STAGE.CREATE || this.state.stage === COMMON_FORM_STAGE.PROCEED) ? ' cmDisabledInput' : ''}${this.state.printFields.identity ? '' : ' noPrint'}${this.state.invalidFields.identity ? ' invalidField' : ''}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="identity"
                                        checked={this.state.printFields.identity}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <Grid item xs={12}>
                                        <IdentityInput
                                            stage={this.state.stage}
                                            identity={this.state.identity}
                                            identityNo={this.state.identityNo}
                                            checksum={this.state.checksum}
                                            changeIdentity={this.changeIdentity}
                                            changeIdentityNo={this.changeIdentityNo}
                                            changeChecksum={this.changeChecksum}/>
                                    </Grid>
                                </div>
                                <div
                                    className={`cmInput cmFormInput${this.state.stage !== CREATE_FORM_STAGE.CREATE ? ' cmDisabledInput' : ''}${this.state.printFields.chassisNo ? '' : ' noPrint'}${this.state.invalidFields.chassisNo ? ' invalidField' : ''}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="chassisNo"
                                        checked={this.state.printFields.chassisNo}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Chassis Number"
                                        value={this.state.chassisNo}
                                        onChange={this.changeChassisNo}
                                        disabled={this.state.stage !== CREATE_FORM_STAGE.CREATE}
                                        InputProps={{disableUnderline: true}}/>
                                </div>
                                <div
                                    className={`cmInput cmFormInput${stagesEditable.indexOf(this.state.stage) === -1 ? ' cmDisabledInput' : ''}${this.state.printFields.license ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="license"
                                        checked={this.state.printFields.license}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="License Plate Number (Optional)"
                                        value={(this.state.stage === '' || !(stagesEditable.indexOf(this.state.stage) === -1 && this.state.license === '')) ? this.state.license : 'N/A'}
                                        onChange={this.changeLicense}
                                        disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                        InputProps={{disableUnderline: true}}/>
                                </div>
                                <div
                                    className={`cmInput cmFormInput cmDisabledInput${this.state.printFields.insurer ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="insurer"
                                        checked={this.state.printFields.insurer}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Insurance Company"
                                        value={this.props.auth().insurer.label}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </div>
                                {this.state.subagent !== '' &&
                                <div
                                    className={`cmInput cmFormInput cmDisabledInput${this.state.printFields.subagent ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="subagent"
                                        checked={this.state.printFields.subagent}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Sub-agent Company"
                                        value={this.state.subagent}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </div>}
                                <div
                                    className={`cmInput cmDateInputContainer${stagesEditable.indexOf(this.state.stage) === -1 ? ' cmDisabledInput' : ''}${this.state.printFields.coverPeriod ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="coverPeriod"
                                        checked={this.state.printFields.coverPeriod}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <Grid item xs={12}>
                                        <Grid className="cmDateInput" item xs={4}>
                                            <TextField
                                                label="Cover Period (days)"
                                                type="number"
                                                value={this.state.coverPeriod}
                                                onChange={this.changeCoverPeriod}
                                                disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                                InputProps={{disableUnderline: true}}/>
                                        </Grid>
                                        <Grid className="cmDateInput commonFormDate" item xs={4}>
                                            <label className="cmInputLabel">Start Date</label>
                                            {/* <Calendar date={this.state.startDate}
                                                      onChange={(newDate) => this.changeStartDate(newDate)}
                                                      disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                                      timeFormat={true}/> */}
                                            <CustomDatePicker 
                                                selected={this.state.startDate.toDate()} 
                                                onChange={(newDate) => this.changeStartDate(moment(newDate))}
                                                disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                                showTimeInput
                                                showTimeSelect={false}
                                                />
                                            
                                        </Grid>
                                        <Grid className="cmDateInput commonFormDate" item xs={4}>
                                            <label className="cmInputLabel">End Date</label>
                                            {/* <Calendar date={this.state.endDate}
                                                      onChange={(newDate) => this.changeEndDate(newDate)}
                                                      disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                                      isValidDate={(date) => this.state.startDate.isBefore(date)}
                                                      timeFormat={true}/> */}
                                                      <CustomDatePicker 
                                                selected={this.state.endDate.toDate()} 
                                                onChange={(newDate) => this.changeEndDate(moment(newDate))}
                                                disabled={stagesEditable.indexOf(this.state.stage) === -1}
                                                minDate={moment(this.state.startDate).add(1,'day').toDate()}
                                                showTimeInput
                                                showTimeSelect={false}
                                                /> 
                                        </Grid>
                                    </Grid>
                                </div>
                                {this.state.stage === UPDATE_FORM_STAGE.CONFIRM_VOID &&
                                <div className="cmInput cmDateInputContainer cmVoidDate">
                                    <Grid className="cmDateInput" item xs={4}>
                                        <label className="cmInputLabel">Void Date</label>
                                        <Calendar date={this.state.voidDate}
                                                  onChange={(newDate) => this.changeVoidDate(newDate)}
                                                  disabled={false}
                                                  isValidDate={(date) => !this.state.startDate.isAfter(this.getEndDate(moment(date)))}/>
                                    </Grid>
                                </div>}
                                {(stagesWithoutStatus.indexOf(this.state.stage) === -1) &&
                                <div
                                    className={`cmInput cmFormInput cmDisabledInput${this.state.printFields.policyType ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="policyType"
                                        checked={this.state.printFields.policyType}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Policy Type"
                                        value={this.state.policyType}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </div>}
                                {(stagesWithoutStatus.indexOf(this.state.stage) === -1) &&
                                <div
                                    className={`cmInput cmFormInput cmDisabledInput${this.state.printFields.status ? '' : ' noPrint'}`}>
                                    {(stagesCanPrint.indexOf(this.state.stage) !== -1) &&
                                    <Checkbox
                                        className="cmCheckbox cmPrintFieldCheckbox"
                                        name="status"
                                        checked={this.state.printFields.status}
                                        onChange={this.changePrintField}
                                        color="default"/>}
                                    <TextField
                                        label="Status"
                                        value={this.state.status}
                                        disabled={true}
                                        InputProps={{disableUnderline: true}}/>
                                </div>}
                                {this.state.history.length ? <HistoryDropDown history={this.state.history}/> : null}
                                {this.state.qrCode !== '' &&
                                <QRCodeDownloadable
                                    src={`data:image/png;base64,${this.state.qrCode}`}
                                    filename={`${this.state.issueNo}.png`}/>}
                            </div>
                            <div>
                                <ErrorHandler onError={this.onError}/>
                                <CommonFormActionButtons
                                    formType={this.props.formType}
                                    stage={this.state.stage}
                                    flowStatus={this.state.flowStatus}
                                    changeStage={(stage) => this.changeStage(stage)}
                                    clickSubmit={this.clickSubmit}
                                    clickConfirm={this.clickConfirm}
                                    clickUpdate={this.clickUpdate}
                                    clickProceed={this.clickProceed}
                                    clickApprove={this.clickApprove}
                                    clickApproveAndIssue={this.clickApproveAndIssue}
                                    clickVoid={this.clickVoid}
                                    clickPrint={this.clickPrint}
                                    clickClose={this.clickClose}
                                    redirect={(formType, stage) => this.redirect(formType, stage)}
                                    loading={this.state.btnLoading}/>
                            </div>
                        </div>
                    </div> :
                    <img className="cmCenter" src={pageSpinner}/>}
                {this.state.displayModal &&
                <Modal
                    content={this.getModalContent()}
                    leftBtn="Cancel"
                    rightBtn="Proceed"
                    clickCancel={(e) => this.handleModal(e, false)}
                    clickConfirm={(e) => this.handleModal(e, true)}/>}
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommonForm));



// WEBPACK FOOTER //
// ./src/Components/Form/CommonForm.tsx